// Node imports
import { Container, delayedCall, dispatcher, ingenuity, killDelayedCall, Label, SpineBase } from "@quest/base-core";
import {
  IntroOutroControllerBehavior,
  IntroOutroViewBehavior,
  SlotAnimationConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist/";
import { Linear } from "@quest/pixi-bridge";
import { SlotEventConstants } from "@quest/slot-core";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class IntroOutroControllerGame extends IntroOutroControllerBehavior {
  private introPopupBG: any;
  private continueTextOutro: Label;
  private outroPopupBG: any;
  private transitionAnim: SpineBase;
  private outroAmountContainer: Container;
  private continueText: Label;
  constructor(view: IntroOutroViewBehavior) {
    super(view);
    this.overrideBehaviorValues();
  }

  protected playFgIntroDesktopSpine(): void {
    super.playFgIntroDesktopSpine();
    this.continueButton.visible = false;
  }

  protected initializeElements(): void {
    super.initializeElements();
    this.outroPopupBG = this.view.getShapeById("outroPopupBG");
    this.introPopupBG = this.view.getShapeById("introPopupBG");
    this.continueTextOutro = this.view.getLabelById("continueTextOutro") as Label;
    this.transitionAnim = this.view.getSpineById("Transition_effect");
    this.continueText = this.view.getLabelById("continueText") as Label;
    this.outroAmountContainer = this.view.getContainerByID("winAmountContainer");
    this.OutroWinAmount.rotation = 0;
  }

  // Overrided to initialize elements
  protected initializePortraitComponent(): void {
    this.freeGameIntroPortraitSpine = this.view.getContainerByID("fgIntroBgAnimPort").children[0];
    this.fgOutroPortraitBGSpine = this.view.getContainerByID("fgOutroPortraitBGSpineContainer").children[0];
  }

  // Overrided to remove text spine call for portrait
  protected playFgIntroPortraitSpine(): void {
    this.playFgIntroPortraitBgSpine();
  }

  /**
   * Overrided to Play fg outro bg portrait spine
   */
  protected playFgOutroPortraitSpine(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO_FG);
    this.fgOutroPortraitBGSpine.setPause(false);
    this.fgOutroPortraitBGSpine.visible = true;
    this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_IN, false);
    this.fgOutroPortraitBGSpine.onComplete.addOnce(() => {
      this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP, true);
    }, this);
  }

  /**
   * override to set pause for text animation 
   */

  protected hideFgOutroSpine(): void {
    super.hideFgOutroSpine();
    this.outroTextSpine.visible = false;
          this.outroTextSpine.setPause(true);
          this.outroTextSpine.onComplete.dispose();
  }

  // Overrided to play fg outro portrait bg animation
  protected onOutroOutSpinEndPortrait(): void {
    this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_OUT, false);
  }

  /**
   * override to add transition animation and reduce delay time
   */
  protected introShowDelay(): void {
    this.playTransitionAnim();
    delayedCall(
      SlotConstantsBehavior.INTRO_SHOW_DELAY,
      900,
      () => {
        killDelayedCall(SlotConstantsBehavior.INTRO_SHOW_DELAY);
        this.IntroContainer.visible = true;
        this.IntroContainer.alpha = 1;
        this.startFreeGameState();
        this.playFreeGameIntroSpine();
      },
      this
    );
  }

  protected startFreeGameState(): void {
    super.startFreeGameState();
    dispatcher.fireEvent(SlotEventConstants.SUBSCRIBE_FREEGAME_WIN_PRESENTATION_EVENTS);
  }

  /**
   * function to play transition animation
   * freegame to basegame, basegame to freegame
   */
  private playTransitionAnim() {
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.TRANSITION_SCREEN_SOUND,
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_POSTLOAD
    );
    this.transitionAnim.visible = true;
    this.transitionAnim.playAnim("transition", false);
    this.transitionAnim.onComplete.addOnce(() => {
      this.transitionAnim.visible = false;
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
        id: SoundConstantGame.TRANSITION_SCREEN_SOUND,
        key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
      });
    }, this);
  }

  /**
   * overide to stop freegame bgm
   */
  protected onOutroShow(): void {
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG);
    super.onOutroShow();
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.FREGAME_BGLOOP, key: "soundList_1" });
  }

  /**
   *overide to add total spin count
   */
  protected playfgIntroBgSpine(): void {
    ingenuity.currentGame.stage.addChild(this.view);
    this.totalSpinTriggered.visible = true;
    this.tweenTotalSpin();
    this.freeGameIntroSpine.setPause(false);
    this.freeGameIntroSpine.visible = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN, false);
    this.freeGameIntroSpine.onComplete.addOnce(() => {
      this.onStageClick();
      this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC, true);
    }, this);
  }

  protected onIntroShow(): void {
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG);
    ingenuity.configData.showLogoBaseGameScreen = false;
    super.onIntroShow();
    ingenuity.currentGame.stage.addChild(this.view);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
  }

  /**
   * tween total spins count as spine
   */
  private tweenTotalSpin(): void {
    ingenuity.currentGame.add
      .tween(this.textAndNumberContainer)
      .to({ y: this.textAndNumberContainer.y + 5 }, 300, Linear.None, true, 0, -1, true);
  }

  // To play free game intro text spine animation
   protected playfgIntroTextSpine():void {
        this.introTextSpine.setPause(false);
        this.introTextSpine.visible = true;
        this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_IN, false);
        this.introTextSpine.onComplete.addOnce(() => {
            this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC, true);
            //this.enableContinueButton();
        }, this);
    }

  /**
   * add stage click to intro container
   */
  private onStageClick(): void {
    this.continueText.visible = true;
    this.introPopupBG.interactive = true;
    this.introPopupBG.inputEnabled = true;
    this.introPopupBG &&
      this.introPopupBG.events.onInputUp.add((e: any) => {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false });
        this.onContinuePressUP();
        this.offStageClick();
      }, this);
  }

  protected onContinuePressUP(): void {
        this.continueButton.visible = false;
        this.freeGameIntroSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT, false);
        this.freeGameIntroSpine.onComplete.addOnce(() => {
            this.freeGameIntroSpine.visible = false;
        }, this);
        this.introTextSpine.playAnim(SlotAnimationConstant.FG_INTRO_DESKTOP_OUT, false);
        this.introTextSpine.onComplete.addOnce(() => {
            this.introTextSpine.visible = false;
        }, this);
        this.introTextSpine.onComplete.addOnce(() => {
            this.introTextSpine.visible = false;
            this.freeGameIntroSpine.visible = false;
            this.onIntroSpinEnds();
        }, this);
        !ingenuity.deviceEnv.isDesktop && this.onPortraitIntroSpinEnds();
        this.hideTextAndNumberWithFadeOut();
  }


   /**
     * Hide free game intro banner
     */
   protected onIntroContinuePressUp() :void {
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP });
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
        dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
        dispatcher.fireEvent(SlotEventConstantsBehavior.UNSUBSCRIBE_BASEVIEW_EVENTS);
        dispatcher.fireEvent(SlotEventConstants.SHOW_FREEGAME_VIEW);
        this.resetIntroComponent();
        delayedCall(SlotConstantsBehavior.START_FG_SPIN_DELAY, SlotConstantsBehavior.DURATION_500, () => {
            killDelayedCall(SlotConstantsBehavior.START_FG_SPIN_DELAY);
            dispatcher.fireEvent(SlotEventConstantsBehavior.START_FG_SPIN);
        }, this);
    }

    /**
     * handle reset of outro continue button
     */
    protected resetOutroContinueButton():void {
        var _a;
        (_a = this.OutroContinueBtn) === null || _a === void 0 ? void 0 : _a.disableAndTint();
        this.OutroContinueBtn && (this.OutroContinueBtn.alpha = 0);
    }

  /**
   * remove stage click sfter click from intro container
   */
  private offStageClick(): void {
    this.introPopupBG.interactive = false;
    this.introPopupBG.inputEnabled = false;
    this.introPopupBG && this.introPopupBG.events.onInputUp.dispose();
    this.continueText.visible = false;
  }

  /**
   * add stage click to outro container
   */
  private onStageClickOutro(): void {
    this.continueTextOutro.visible = true;
    this.outroPopupBG.interactive = true;
    this.outroPopupBG.inputEnabled = true;
    this.outroPopupBG &&
      this.outroPopupBG.events.onInputUp.add((e: any) => {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false });
        if (this.outroWinAmount) {
          this.onOutroContinuePressUp();
        } else {
          this.onOutroContinuePressUpForNoWin();
        }
        this.offStageClickOutro();
      }, this);
  }

  /**
   * remove stage click sfter click from outro container
   */
  private offStageClickOutro(): void {
    this.continueTextOutro.visible = false;
    this.outroPopupBG.interactive = false;
    this.outroPopupBG.inputEnabled = false;
    this.outroPopupBG && this.outroPopupBG.events.onInputUp.dispose();
  }

  /**
   *
   */
  // private tweenOutroAmountContainer(): void {
  //   ingenuity.currentGame.add.tween(this.outroAmountContainer.scale).to({ x: 1.05, y: 1.02 }, 600, Linear.None, true, 0, -1, true);
  // }
  /**
   * overide to remove auto fade in and add stage click
   */
  protected startOutroWinAmountTickup(): void {
    //this.tweenOutroAmountContainer();
    var _a;
    this.OutroWinAmount.visible = true;
    this.OutroWinAmount.setValue(0);
    this.outroAmountContainer.visible = true;
    this.outroAmountContainer.alpha = 1;
    (_a = this.OutroWinAmount) === null || _a === void 0
      ? void 0
      : _a.startTick(this.outroWinAmount, true, false, 6, true, () => {
          this.continueTextOutro.visible = true;
          this.onStageClickOutro();
        });
  }

  protected onOutroContinuePressUpForNoWin(): void {
    this.playTransitionAnim();
    delayedCall("playOutroNoWinAnim", 500, () => {
      killDelayedCall("playOutroNoWinAnim");
      super.onOutroContinuePressUpForNoWin();
    });
  }

  /**
   * overide to add transition animation
   */
  protected onOutroContinuePressUp(): void {
    SlotConstantsBehavior.FREEGAME_RETURN_SOUND = true;
    this.playTransitionAnim();
    ingenuity.configData.hideBaseGamePortraitButtonPanel = false;
    delayedCall(
      SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY,
      SlotConstantsBehavior.DURATION_500,
      () => {
        killDelayedCall(SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY);
        this.stopSoundAndShowBaseGame();
        this.onOutroOutSpinEnd();
        dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO);
        this.fgOutroMeterFadeOut();
        delayedCall(
          SlotConstantsBehavior.OUTRO_HIDE_DELAY,
          SlotConstantsBehavior.DURATION_1000,
          () => {
            killDelayedCall(SlotConstantsBehavior.OUTRO_HIDE_DELAY);
            dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
            dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BLUR_BG, {
              name: SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG,
              duration: 0,
            });
            this.OutroContainer.visible = false;
            this.hideFgOutroSpine();
            !ingenuity.deviceEnv.isDesktop && this.hideFgOutroPortraitSpine();
          },
          this
        );
      },
      this
    );
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LARGE_STACK_SYMBOL_FG);
  }

   /**
    * play outro end spine
    */
   onOutroOutSpinEnd():void {
    this.outroTextSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT, false);
    this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_OUT_BG, false);
    !ingenuity.deviceEnv.isDesktop && this.onOutroOutSpinEndPortrait();
}

  // fade onutro amount container
  protected fgOutroMeterFadeOut(): void {
    const amountFadeOutTween = ingenuity.currentGame.add
      .tween(this.outroAmountContainer)
      .to({ alpha: 0 }, SlotConstantsBehavior.DURATION_200, Linear.None, true, 0, 0, false);
    amountFadeOutTween.onComplete.addOnce(() => {
      amountFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(amountFadeOutTween);
    }, this);
  }

  /**
   * override to change animation names
   */
  protected playFgOutroDesktopSpine(): void {
    this.fgOutroSpine.visible = true;
    this.fgOutroSpine.setPause(false);
    this.fgOutroSpine.playAnim("static", false);
    this.fgOutroSpine.onComplete.addOnce(() => {
      this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_IN, false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG);
      this.playFgOutroTextSpine();
    });
  }

  /**
   * override to change animation names
   */
  playFgOutroTextSpine() {
    this.outroTextSpine.setPause(false);
    this.outroTextSpine.onComplete.dispose();
    this.outroTextSpine.visible = true;
    this.outroTextSpine.alpha = 1;
    this.outroTextSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_IN, false);
    this.outroTextSpine.onComplete.addOnce(() => {
      this.startOutroTickup();
      this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_LOOP, true);
      this.outroTextSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_LOOP, true);
    }, this);
  }

  /**
   * Add to show pop up in no win case
   */
  protected showNoWinPopUp() {
    this.continueTextOutro.visible = true;
    this.fgOutroSpineContainer.visible = false;
    this.freeGameCompleteCont.visible = true;
    this.freeGameCompleteCont.alpha = 0;
    const fadeInTween = ingenuity.currentGame.add.tween(this.freeGameCompleteCont).to({ alpha: 1 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      this.onStageClickOutro();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
  }

  // Overrided to hide fg outro portrait spine
  protected hideFgOutroPortraitSpine(): void {
    this.fgOutroPortraitBGSpine.visible = false;
    this.fgOutroPortraitBGSpine.setPause(true);
    this.fgOutroPortraitBGSpine.onComplete.dispose();
  }

  // Overrided to play portrait intro end spine
  protected onPortraitIntroSpinEnds(): void {
    this.freeGameIntroPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT, false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.freeGameIntroPortraitSpine.visible = false;
      this.freeGameIntroPortraitSpine.setPause(true);
      this.freeGameIntroPortraitSpine.onComplete.dispose();
    }, this);
  }

  protected onOutroHide(): void {
    ingenuity.configData.showLogoBaseGameScreen = true;
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG);
    super.onOutroHide();
  }

  
  private overrideBehaviorValues(): void {
    this.FG_INTRO_DESKTOP_IN = "in";
    this.FG_INTRO_DESKTOP_BG_IN = "in_bg_desktop";
    this.FG_INTRO_DESKTOP_BG_STATIC = "loop_bg_desktop";
    this.FG_INTRO_DESKTOP_BG_OUT = "out_bg_desktop";
    this.FG_INTRO_DESKTOP_OUT = "out";
    this.FG_INTRO_DESKTOP_STATIC = "loop";
    this.FG_INTRO_PORTRAIT_BG_IN = "in_bg_portrait";
    this.FG_INTRO_PORTRAIT_IN = "in";
    this.FG_INTRO_PORTRAIT_BG_STATIC = "loop_bg_portrait";
    this.FG_INTRO_PORTRAIT_BG_OUT = "out_bg_portrait";
    this.FG_INTRO_PORTRAIT_OUT = "out";
    this.FG_INTRO_PORTRAIT_STATIC = "loop";
    this.FG_OUTRO_DESKTOP_BG_IN = "in_bg_desktop";
    this.FG_OUTRO_DESKTOP_BG_LOOP = "loop_bg_desktop";
    this.FG_OUTRO_DESKTOP_OUT = "out";
    this.FG_OUTRO_DESKTOP_OUT_BG = "out_bg_desktop";
    this.FG_OUTRO_PORTRAIT_BG_IN = "in_bg_portrait";
    this.FG_OUTRO_PORTRAIT_IN = "in";
    this.FG_OUTRO_PORTRAIT_BG_OUT = "out_bg_portrait";
    this.FG_OUTRO_PORTRAIT_BG_LOOP = "loop_bg_portrait";
    this.FG_OUTRO_PORTRAIT_LOOP = "loop";
    this.FG_OUTRO_PORTRAIT_OUT = "out";
    this.FG_OUTRO_DESKTOP_LOOP = "loop";
    this.FG_OUTRO_DESKTOP_IN = "in";
    this.FS_OUTRO_NUMBER_ROTATION = 0;
  }
}
